export const Message = {
  Resize: (id) => `LiquidResize_${id}-iframe`,
  AddToCart: 'LiquidAddToCart',
  Navigate: 'LiquidNavigate',
  ToggleCart: 'LiquidToggleCart',
  OverlayClicked: 'LiquidOverlayClicked',

  SetConfigs: 'LiquidSetConfigs',
  Initialized: 'LiquidInitialized',

  // Shared (App/SDK) events
  AddressCanceledChange: 'LiquidAddressCanceledChange',
  AddressChanged: 'LiquidAddressChanged',
  CartLoading: 'LiquidCartLoading',
  CartLoaded: 'LiquidCartLoaded',
  CartGet: 'LiquidCartGet',
  CartGetSuccess: 'LiquidCartGetSuccess',
  CartUpdate: 'LiquidCartUpdate',
  CartUpdated: 'LiquidCartUpdated',
  CartItemAdd: 'LiquidCartItemAdd',
  CartItemAdded: 'LiquidCartItemAdded',
  CartItemChanged: 'LiquidCartItemChanged',
  CartItemRemoved: 'LiquidCartItemRemoved',
  CartToggled: 'LiquidCartToggled',
  ProductLoading: 'LiquidProductLoading',
  ProductLoaded: 'LiquidProductLoaded',
  UpdatePDP: 'LiquidCartToggled',
  GetProduct: 'LiquidGetProduct',
  GetProductSuccess: 'LiquidGetProductSuccess',

  // Tracking events
  InitTracking: 'LiquidInitTracking',
  Track: 'LiquidTrack',

  // Storage events
  StorageGet: 'LiquidStorageGet',
  StorageSet: 'LiquidStorageSet',
  StorageGetSuccess: (id) => `LiquidStorageGetSuccess_${id}`,
  StorageSetSuccess: (id) => `LiquidStorageSetSuccess_${id}`,
};

class PubSub {
  subscribers = {};
  target = window.parent;
  url = window.location.href;

  constructor() {
    window.addEventListener('message', (event) => {
      const message = event.data;
      const { type, data } = message;
      if (!type || !this.subscribers[type]) {
        return;
      }

      this.subscribers[type].forEach((subscriber) => subscriber(data));
    });
  }

  publish(type, data) {
    const message = {
      type: type || this.url,
      data,
    };

    this.target.postMessage(message, '*');
  }

  subscribe(type, subscriber) {
    if (!this.subscribers[type]) {
      this.subscribers[type] = [];
    }

    this.subscribers[type].push(subscriber);

    return {
      unsubscribe: () => this.unsubscribe(type, subscriber),
    }
  }

  unsubscribe(type, subscriber) {
    if (!this.subscribers[type]) {
      return;
    }

    const index = this.subscribers[type].indexOf(subscriber);

    if (index !== -1) {
      this.subscribers[type].splice(index, 1);
    }
  }
}

const pubSub = new PubSub();
export default pubSub;
